<template>
  <v-menu
    offset-y
    min-width="232">
    <template #activator="{ on }">
      <button
        class="env-switch"
        v-on="on">
        <span
          class="env-switch__dot"
          :style="{ background: $env.color, boxShadow: `0 0 0 3px ${$env.light}` }" />
        <span class="env-switch__text">
          <span class="env-switch__label">{{ $env.label }}</span>
          <span class="env-switch__host">{{ $env.api.replace(/^https?:\/\//, '') }}</span>
        </span>
        <v-icon size="16">
          mdi-unfold-more-horizontal
        </v-icon>
      </button>
    </template>
    <v-list
      dense
      class="py-1">
      <v-subheader class="env-switch__title">
        Changer d'environnement
      </v-subheader>
      <v-list-item
        v-for="env in environments"
        :key="env.key"
        @click="selectEnv(env)">
        <span
          class="env-switch__dot mr-3"
          :style="{ background: env.color }" />
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            {{ env.label }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ env.api.replace(/^https?:\/\//, '') }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-icon
          v-if="env.key === $env.key"
          small>
          mdi-check
        </v-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import Api from '@batimentb/vadimm-js-api'
  import { ENVIRONMENTS, switchEnv, tokenKey } from '../environments'

  export default {
    name: 'EnvSwitch',
    data () {
      return {
        environments: ENVIRONMENTS
      }
    },
    methods: {
      async selectEnv (env) {
        if (env.key === this.$env.key) return
        if (env.key === 'prod') {
          const ok = await this.$confirm({
            title: 'Passer sur la prod ?',
            message: 'Tu vas voir et modifier les vraies données clients.',
            confirmLabel: 'Passer sur la prod',
            danger: true
          })
          if (!ok) return
        }
        await this.shareSession(env)
        switchEnv(env.key)
      },
      // Même compte superadmin sur l'env visé : on reprend la session actuelle, sinon reconnexion
      async shareSession (env) {
        const { token, currentUser } = this.$store.state
        if (!token || !currentUser) return
        try {
          const client = new Api.Client({ host: env.api })
          client.axios.defaults.timeout = 5000
          client.setToken(token)
          const { data } = await client.getCurrentUser()
          if (data.email === currentUser.email && data.profil === 'superadmin') {
            localStorage.setItem(tokenKey(env), token)
          }
        } catch (e) {
          // session refusée sur l'env visé : on garde le comportement normal (connexion)
        }
      }
    }
  }
</script>

<style scoped>
  .env-switch {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 10px 9px 12px;
    border-radius: 12px;
    background: white;
    border: 1px solid #ececef;
    text-align: left;
    cursor: pointer;
  }
  .env-switch:hover {
    border-color: #d4d4d8;
  }
  .env-switch__dot {
    flex: none;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .env-switch__text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    line-height: 1.25;
  }
  .env-switch__label {
    font-size: 13px;
    font-weight: 700;
  }
  .env-switch__host {
    font-size: 11.5px;
    color: #7a7a85;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .env-switch__title {
    height: 32px;
    font-size: 12px;
  }
</style>
